import {Currency} from './currency';

interface IUserCredit {
  accountLevel: string;
  pricePerCredit: number;
  currency: Currency;
  availableCredits: number;
  currentMonthUsedCredits: number;
}

export class UserCredits {
  accountLevel: string;
  pricePerCredit: number;
  currency: Currency;
  availableCredits: number;
  currentMonthUsedCredits: number;

  constructor(userCredit?: IUserCredit) {
    if (userCredit) {
      this.accountLevel = userCredit.accountLevel;
      this.pricePerCredit = userCredit.pricePerCredit;
      this.currency = userCredit.currency;
      this.availableCredits = userCredit.availableCredits;
      this.currentMonthUsedCredits = userCredit.currentMonthUsedCredits;
    }
  }
}



// WEBPACK FOOTER //
// ./src/models/Billing/user-credits.ts